import { IMessage } from "~contexts/Socket/interfaces";

export const getStyles = (theme: any, replyingTo: IMessage | null) => ({
  styles: {
    wrapper: {
      backgroundColor: theme.palette.grey[700],
      minHeight: "100vh",
      minWidth: "100vw",
      display: "flex",
      justifyContent: "space-between",
    },
    content: {
      height: "100vh",
      flex: 1,
      padding: "56px",
      display: "flex",
      flexDirection: "column",
      borderRadius: "0px 60px 0px 0px",
      backgroundColor: theme.palette.grey[900],
    },
    room: {
      height: replyingTo ? "calc(100% - 126px)" : "100%",
      overflowY: "scroll" as "scroll",
      marginTop: "24px",
      padding: "24px",
      border: `1px solid ${theme.palette.grey[500_8]}`,
      borderRadius: "16px",
      backgroundColor: theme.palette.grey[700],
      position: "relative" as "relative",

      "&::-webkit-scrollbar": {
        width: "10px",
      },

      "&::-webkit-scrollbar-thumb": {
        background: theme.palette.grey[900],
        borderRadius: "16px",
        border: `1px solid ${theme.palette.grey[300]}`,
      },
    },
    roomButton: {
      borderRadius: "50%",
      border: "none",
      bottom: "calc(56px + 40px)",
      cursor: "pointer",
      height: "65px",
      position: "fixed" as "fixed",
      right: "calc(350px + 56px + 72px)",
      width: "65px",
    },
    roomButtonCount: {
      alignItems: "center",
      backgroundColor: "#000",
      borderRadius: "50%",
      border: "none",
      color: "#fff",
      display: "flex",
      fontSize: "14px",
      fontWeight: 400,
      height: "30px",
      justifyContent: "center",
      left: 0,
      padding: '5px',
      position: "absolute" as "absolute",
      top: "-10px",
      width: "30px",
    },
  },
});
